module.exports = __webpack_public_path__ + "media/images/pc/brands/aqua/store_kamakura-a165598aff2220da99bee655aca5b685.jpg";